import { DropdownSearchItem } from '@/modules/common/components/molecules/selectors/dropdown';

import { ShortClientResponse } from '../types/dto/client-short.dto';

/**
 * Maps ShortClientResponse DTO to DropdownSearchItem for use in selectors
 * @param dto - Client response from API
 * @returns Dropdown search item with client data
 */
export const mapShortClientToDropdownItem = (dto: ShortClientResponse): DropdownSearchItem => {
  return {
    id: String(dto.id),
    name: dto.name,
    avatarLink: dto.logoUrl ?? undefined,
    secondaryText: undefined, // Clients don't have secondary text in short response
  };
};

/**
 * Maps array of ShortClientResponse DTOs to DropdownSearchItem array
 * @param dtos - Array of client responses from API
 * @returns Array of dropdown search items
 */
export const mapShortClientsToDropdownItems = (
  dtos: ShortClientResponse[]
): DropdownSearchItem[] => {
  return dtos.map(mapShortClientToDropdownItem);
};
